import React from 'react';
import PropTypes from 'prop-types';
import TileWidget from '../../Desktop/TopicTile/TopicTileWrapper';
import s from './NoResultTopStories.scss';

function NoResultTopStories(props) {
  const { topStories, noResultTextToDisplay, noTabRender, selectedTab } = props;
  return (
    <div className={`${s.notresult} ${noTabRender ? s.noTabRender : ``}`}>
      <i />
      <div className={s.searchResultData}>{noResultTextToDisplay}</div>
      <TileWidget
        allepisodes={topStories}
        headingName="Explore Top Stories on TOI"
        hideNewsMoreButton
        frmNoResultTopStories
        selectedTab={selectedTab}
      />
    </div>
  );
}

NoResultTopStories.propTypes = {
  noTabRender: PropTypes.bool,
  noResultTextToDisplay: PropTypes.string,
  selectedTab: PropTypes.string,
};
NoResultTopStories.defaultProps = {
  noTabRender: false,
  noResultTextToDisplay: '',
  selectedTab: '',
};

export default NoResultTopStories;
